<template lang="pug">
  .height-100
    h3.title Mis datos
    p

    transition-group.contenedor-box(name="fade-smooth-two", tag="div")
      .box(v-if="mostrarDatosFotoPerfil", key="datos-foto-perfil")
        datos-personales-foto-perfil(
          @close="mostrarDatosFotoPerfil = false"
        )
      .box(v-if="mostrarDatosSeguridad", key="datos-seguridad")
        datos-personales-seguridad(
          @close="mostrarDatosSeguridad = false"
        )
      .box(v-if="mostrarDatosConsulta", key="datos-consulta")
        datos-personales-consulta(
          @close="mostrarDatosConsulta = false"
        )
      .box(v-if="mostrarDatosEditable", key="datos-editable")
        datos-personales-editable(
          @close="mostrarDatosEditable = false"
        )
</template>

<script>
import DatosPersonalesSeguridad from './Component_Datos_Personales_Seguridad'
import DatosPersonalesConsulta from './Component_Datos_Personales_Consulta'
import DatosPersonalesEditable from './Component_Datos_Personales_Editable'
import DatosPersonalesFotoPerfil from './Component_Datos_Personales_Foto_Perfil'
export default {
  name: 'mis-datos',
  components: {
    DatosPersonalesSeguridad,
    DatosPersonalesConsulta,
    DatosPersonalesEditable,
    DatosPersonalesFotoPerfil
  },
  data () {
    return {
      mostrarDatosSeguridad: true,
      mostrarDatosConsulta: true,
      mostrarDatosEditable: true,
      mostrarDatosFotoPerfil: true,
      username : localStorage.getItem('username')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .contenedor-box
    display flex
    justify-content center
    flex-direction column
    position relative
    >*
      transition all .5s
      width 100%

.box
  position: relative
</style>



// WEBPACK FOOTER //
// View_Mis_Datos.vue?d073db0e